import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateLocationBusinessHoursMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountLocationBusinessHoursInput;
}>;

export type UpdateLocationBusinessHoursMutationResult = { __typename?: 'Mutation' } & {
  updateAccountLocationBusinessHours?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountLocationBusinessHoursPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateLocationBusinessHoursDocument = /*#__PURE__*/ gql`
  mutation updateLocationBusinessHours($input: UpdateAccountLocationBusinessHoursInput!) {
    updateAccountLocationBusinessHours(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateLocationBusinessHoursMutation__
 *
 * To run a mutation, you first call `useUpdateLocationBusinessHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationBusinessHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationBusinessHoursMutation, { data, loading, error }] = useUpdateLocationBusinessHoursMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationBusinessHoursMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLocationBusinessHoursMutationResult,
    UpdateLocationBusinessHoursMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateLocationBusinessHoursMutationResult, UpdateLocationBusinessHoursMutationVariables>(
    UpdateLocationBusinessHoursDocument,
    options
  );
}
export type UpdateLocationBusinessHoursMutationHookResult = ReturnType<typeof useUpdateLocationBusinessHoursMutation>;
